import { apiService } from './api';
import { logger } from '../utils/logger';


export interface UserImportError {
  row: number;
  field: string;
  error: string;
  value: string;
}

export interface UserImportSuccess {
  row: number;
  cmsUserId: string;
  fullName: string;
  email: string;
  userId: string;
}

export interface UserImportResult {
  success: boolean;
  totalRows: number;
  successfulImports: number;
  failedImports: number;
  errors: UserImportError[];
  successes: UserImportSuccess[];
  message: string;
}

export const userImportService = {
  /**
   * Import users from Excel/CSV file
   */
  async importUsers(file: File): Promise<UserImportResult> {
    const formData = new FormData();
    formData.append('file', file);

    logger.log('📤 Sending FormData to API...', file.name);

    // Use fetch directly for FormData to avoid JSON.stringify issues
    // Get user ID from sessionStorage for authentication
    const userData = sessionStorage.getItem('user');
    const userId = userData ? JSON.parse(userData).id : null;
    const schoolCode = localStorage.getItem('schoolCode');

    const response = await fetch(`/api/users/import`, {
      method: 'POST',
      headers: {
        'x-user-id': userId || '',
        'x-school-code': schoolCode || '',
      },
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    logger.log('📥 API response received:', result);
    return result;
  },

  /**
   * Download Excel template for user import
   */
  async downloadTemplate(): Promise<void> {
    // Use fetch directly to get Excel .xlsx file
    // Get user ID from sessionStorage for authentication
    const userData = sessionStorage.getItem('user');
    const userId = userData ? JSON.parse(userData).id : null;
    const schoolCode = localStorage.getItem('schoolCode');

    const response = await fetch(`/api/users/template`, {
      method: 'GET',
      headers: {
        'x-user-id': userId || '',
        'x-school-code': schoolCode || '',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get Excel file as blob
    const blob = await response.blob();
    logger.log('📄 Excel file received:', blob.size, 'bytes');

    // Create blob link to download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'user-import-template.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};

